import css from '@styled-system/css'
import styled from 'styled-components'
import { ResponsiveValue, variant } from 'styled-system'

import { Icon } from '../images'
import { mdBumps } from '../layout'

export type PromotionalBannerActivatedProperty = 'default'

export interface PromotionalBannerActivatedProps {
  variant?: ResponsiveValue<PromotionalBannerActivatedProperty>
}

export const PromotionalBannerActivated = styled.div<PromotionalBannerActivatedProps>(
  css({
    color: 'foregroundPromoActivated',
    backgroundColor: 'backgroundPromoActivated',
    borderRadius: 2,
    p: mdBumps,
    width: '100%',
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    alignItems: ['flex-start', 'flex-start', 'center'],
    justifyContent: 'space-between',
    [Icon]: {
      path: {
        fill: 'foregroundPromoActivated',
      },
    },
  }),
  variant({
    scale: 'PromotionalBannerActivated',
    variants: {
      default: {},
    },
  }),
)
